import { ComponentType, SVGProps } from 'react';
import { InfoIcon, LampIcon, MegaphoneIcon, StarIcon } from '../../assets/icons';

export type RequestType = 'elogio' | 'sugestao' | 'reclamacao' | 'informacao';

type RequestTypeConfig = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  /**
   * O valor que será passado para a API
   */
  value: string;
};

/** Ícone e label de cada tipo de solicitação — reusado pela Home (cards) e por Support (badge). */
export const REQUEST_TYPE_CONFIG: Record<RequestType, RequestTypeConfig> = {
  elogio: { icon: StarIcon, label: 'Elogio', value: 'Elogio' },
  sugestao: { icon: LampIcon, label: 'Sugestão', value: 'Sugestão' },
  reclamacao: { icon: MegaphoneIcon, label: 'Reclamação', value: 'Reclamação' },
  informacao: { icon: InfoIcon, label: 'Informação', value: 'Informação' },
};

export const REQUEST_TYPES = Object.keys(REQUEST_TYPE_CONFIG) as RequestType[];

export function isRequestType(value: string): value is RequestType {
  return (REQUEST_TYPES as string[]).includes(value);
}
